import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderReceivedPopupRoutingModule } from './order-received-popup-routing.module';
import { OrderReceivedPopupComponent } from './order-received-popup.component';
import { SharedModule } from '../shared.module';


@NgModule({
  declarations: [
    OrderReceivedPopupComponent
  ],
  imports: [
    CommonModule,
    OrderReceivedPopupRoutingModule,
    SharedModule
  ]
})
export class OrderReceivedPopupModule { }
